import { render, staticRenderFns } from "./InvoicePositions.vue?vue&type=template&id=40c23d60&scoped=true&"
import script from "./InvoicePositions.vue?vue&type=script&lang=js&"
export * from "./InvoicePositions.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePositions.vue?vue&type=style&index=0&id=40c23d60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c23d60",
  null
  
)

export default component.exports